const { REACT_APP_S3_CLIP_BUCKET } = process.env;

export const BIND = 'bind "f3" "say !allstar"';

export const HERO = {
  headingLead: "Skip clip limits with ",
  headingCommand: "!allstar",
  // The subheading lives in Hero's JSX, not here: it renders !allstar as a
  // <Cmd> token mid-sentence, which a plain string can't carry.
  video: `${REACT_APP_S3_CLIP_BUCKET}/static/web/in-game/example_allstar.mp4`,
  caption: "Someone typing !allstar after a sick 3K",
  // Shown over the demo once it ends, so the page demonstrates the payoff
  // rather than only describing it.
  processingTitle: "Deagle 3K on Dust 2",
};

// Real in-game map render, dimmed hard behind the hero so the page reads as
// Counter-Strike before a word is read. Dust 2 to match the demo clip.
export const HERO_BACKGROUND = `${REACT_APP_S3_CLIP_BUCKET}/static/clip-map-thumbs/de_dust2_1.webp`;

export interface IStep {
  title: string;
  description: string;
}

export const STEPS: IStep[] = [
  {
    title: "Make a play",
    description:
      "Pop off in Premier, Competitive or Wingman. Works on FACEIT and other third-party services too, with nothing open or recording.",
  },
  {
    title: "Type !allstar",
    description:
      "Send it in all-chat after you have made a play, or at the end of the round. No app, no overlay, no alt-tab.",
  },
  {
    title: "Captured automatically",
    description:
      "Once your match is processed we cut every round you called, and none of them count against your clip limit.",
  },
];

export const HOW = {
  headingLead: "How ",
  headingUnderlined: "it works",
};

export const BIND_SECTION = {
  eyebrow: "One-time setup",
  headingLead: "Bind it once, then ",
  headingUnderlined: "one tap clips your round",
  subheading:
    "Paste this into the CS2 console and !allstar is a single key away for every match after it.",
  footnote: "No bind? Just type !allstar in chat, it works the same.",
  helpLabel: "How to add this in CS2",
  helpSteps: [
    "Open the CS2 developer console (the ~ key). If nothing happens, turn it on in Game Settings > Game > Enable Developer Console.",
    "Want a different key? Swap f3 for whatever you like.",
    "Paste the command above into the console and hit Enter.",
    "In a match, tap that key after a play to fire off !allstar.",
  ],
};

export const FEED = {
  headingLead: "Clipped with ",
  headingUnderlined: "!allstar",
  subheading: "The newest clips people called in game, straight from CS2.",
};

export interface IPlan {
  tier: string;
  perks: string[];
}

export const PLANS = {
  headingLead: "Always free. ",
  headingUnderlined: "Never counts against your limit",
  subheading:
    "Every !allstar clip is free to make and never touches your monthly allowance.",
  free: {
    tier: "Free & Basic",
    perks: [
      "Never counts against your clip limit",
      "Always free to use",
      "Allstar-branded loadout",
    ],
  } as IPlan,
  paid: {
    tier: "With Standard or Unlimited",
    perks: [
      "Your own custom loadout and branding",
      "Ability to remove watermark",
      "Priority queues for your clips",
    ],
  } as IPlan,
};

export interface IFaqItem {
  question: string;
  answer: string;
}

export const FAQ: IFaqItem[] = [
  {
    question: "Does it really not use my clip limit?",
    answer:
      "Right. !allstar clips don't draw from your normal clip allowance. If you're tapped out for the month, you can still keep making them in game.",
  },
  {
    question: "Do I need the Allstar app running?",
    answer:
      "No. The command lives in match chat and the clip is built later from the match demo, so nothing has to be open while you play.",
  },
  {
    question: "What if I type it a little late?",
    answer:
      "You're covered. Sent during the next round's buy time or roughly its first 20 seconds, it looks back and clips the round you just finished.",
  },
  {
    question: "Does team chat work?",
    answer:
      "No, say it in all-chat. Team chat isn't recorded into the match demo, so a team-only !allstar won't be picked up.",
  },
  {
    question: "How do I change the bind key?",
    answer:
      'Swap "f3" for any key you like, then paste the line into the CS2 console or your autoexec.',
  },
  {
    question: "Why isn't my clip showing up?",
    answer:
      "First, refresh your match history so we can pick up the latest game. If it still isn't there, upload the demo and we'll clip it for you.",
  },
];

export const FINAL_CTA = {
  headingLead: "Your next round is one ",
  headingUnderlined: "!allstar",
  subheading:
    "Nothing to install and nothing to turn on. Jump in a match and call it.",
};
